export default __webpack_public_path__ + "static/smiley-c21996bc0b7681fa73e14777e5e70f80.svg";